import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { motion, AnimatePresence } from "framer-motion";
import pg from "../../assets/images/logo/new_logo/partners-group.svg";
import rusformat from "../../assets/images/logo/logo_Projects RF.svg";
import labomet from "../../assets/images/logo/logo_Labomet integration.svg";
import ntk from "../../assets/images/logo/new_logo/ntk.svg";
import tehnovse from "../../assets/images/logo/new_logo/tehnovse.svg";
import bstock from "../../assets/images/logo/new_logo/bstock.svg";
import guru from "../../assets/images/logo/new_logo/aitigur.svg";
import cifra from "../../assets/images/logo/new_logo/ciframarket.svg";
import iventorus from "../../assets/images/logo/new_logo/inventorus.svg";
import pognali from "../../assets/images/logo/new_logo/pognali.svg";
import socrat from "../../assets/images/logo/new_logo/sokrat.svg";
import panocam from "../../assets/images/logo/new_logo/panocam.svg";
import pilot from "../../assets/images/logo/logo_Pilottele.svg";
import labomet_t from "../../assets/images/logo/new_logo/labomet_tech.svg";
import skb from "../../assets/images/logo/new_logo/skbchm.svg";
import logistic from "../../assets/images/logo/logo_My Logistic.svg";
import projects_rf from "../../assets/images/logo/new_logo/projects_rf.svg";
import labomet_int from "../../assets/images/logo/new_logo/labomet_int.svg";
import vidgio from "../../assets/images/logo/vidgeo.svg";
import trinity from "../../assets/images/logo/trinity.svg";
import complitech from "../../assets/images/logo/new_logo/complitech.svg";
import "./tabsBlock.css";

export default function TabsBlock() {
  const [activeTab, setActiveTab] = useState(0);

  const handlePrev = () => {
    setActiveTab((prev) => (prev > 0 ? prev - 1 : tabs.length - 1));
  };

  const handleNext = () => {
    setActiveTab((prev) => (prev < tabs.length - 1 ? prev + 1 : 0));
  };

  const handleTabSelect = (index) => {
    setActiveTab(index);
  };

  const tabVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.3, ease: "easeOut" },
    },
    exit: { opacity: 0, y: -20 },
  };

  const tabs = [
    {
      id: "trade",
      title: "Дистрибуция",
      content: (
        <>
          <div className="tabBoxInfo">
            <a href="https://pg.pro" target="_blank">
              <div className="tabBoxImg">
                <img src={pg} alt="logo" />
              </div>
              <p>
                Лидирующий поставщик ИТ-оборудования, компьютерной и бытовой
                техники, потребительской электроники, сложных сетевых решений
              </p>
            </a>
          </div>
          {/* <div className="tabBoxInfo">
            <a href="https://i-t-proekt.pro" target="_blank">
              <img src={rusformat} alt="logo" />
              <p>
                Многопрофильный B2B и B2G системный интегратор с опытом
                реализации инфраструктурных проектов и отраслевых решений на
                объектах государственных и корпоративных заказчиков.
              </p>
            </a>
          </div> */}
          {/* <div className="tabBoxInfo">
            <a href="https://labomet.ru" target="_blank">
              <img src={labomet} alt="logo" />
              <p>
                Поставщик высокотехнологичного промышленного оборудования
                ведущих мировых производителей.
              </p>
            </a>
          </div> */}
          <div className="tabBoxInfo">
            <a href="https://info.tehnovse.ru/" target="_blank">
              <div className="tabBoxImg">
                <img src={tehnovse} alt="logo" />
              </div>
              <p>
                ИТ-платформа для розничной торговли и работы на маркетплейсах, а
                также виртуальная витрина, позволяющая кратно расширять
                ассортимент
              </p>
            </a>
          </div>
          <div className="tabBoxInfo">
            <div className="tabBoxImg">
              <img src={bstock} alt="logo" />
            </div>
            <p>
              Онлайн платформа для реализации складских остатков и неликвидных
              товаров
            </p>
          </div>
          <div className="tabBoxInfo">
            <a href="https://mylogistic.pro/" target="_blank">
              <div className="tabBoxImg">
                <img src={logistic} alt="logo" />
              </div>
              <p>
                Мультисервисный оператор логистических услуг и комплексных
                решений по организации складского хранения и грузоперевозок на
                территории РФ с развитой филиальной сетью и собственным
                автопарком
              </p>
            </a>
          </div>
        </>
      ),
    },
    {
      id: "system_integration",
      title: "Системная интеграция",
      content: (
        <>
          <div className="tabBoxInfo">
            <a href="" target="_blank">
              <div className="tabBoxImg">
                <img src={projects_rf} alt="logo" />
              </div>
              <p>
                Многопрофильный B2B и B2G системный интегратор с опытом
                реализации инфраструктурных проектов и отраслевых решений на
                объектах государственных и корпоративных заказчиков
              </p>
            </a>
          </div>
          {/* <div className="tabBoxInfo">
            <a href="" target="_blank">
              <div className="tabBoxImg">
                <img src={labomet_int} alt="logo" />
              </div>
              <p>
                Поставщик высокотехнологичного промышленного оборудования
                ведущих мировых производителей
              </p>
            </a>
          </div> */}
          <div className="tabBoxInfo">
            <a href="https://ntk.expert/" target="_blank">
              <div className="tabBoxImg">
                <img src={ntk} alt="logo" />
              </div>
              <p>
                Поставщик и интегратор продуктов, технологий и решений для
                комплексного оснащения спортивных объектов и медицинских
                учреждений
              </p>
            </a>
          </div>
          <div className="tabBoxInfo">
            <a href="" target="_blank">
              <div className="tabBoxImg">
                <img src={vidgio} alt="logo" />
              </div>
              <p>
                Строительная компания, специализирующаяся на проектировании и
                строительстве промышленных и коммерческих объектов «под ключ» с
                полным инженерным и сервисным сопровождением
              </p>
            </a>
          </div>
        </>
      ),
    },
    {
      id: "tecnology",
      title: "Технологии и производство",
      content: (
        <>
          <div className="tabBoxInfo">
            <a href="https://panocam.ru/" target="_blank">
              <div className="tabBoxImg">
                <img src={panocam} alt="logo" />
              </div>
              <p>
                Разработчик и производитель систем видеонаблюдения. Резидент
                ИНТЦ «Сириус». Включен в реестр ИТ-компаний Минцифры России
              </p>
            </a>
          </div>
          <div className="tabBoxInfo">
            <a href="https://labomet.ru" target="_blank">
              <div className="tabBoxImg">
                <img src={labomet_t} alt="logo" />
              </div>
              <p>
                Разработчик и производитель опытных образцов оборудования для
                контроля качества и структуры твердых материалов
              </p>
            </a>
          </div>
          <div className="tabBoxInfo">
            <a href="https://skbchm.ru/" target="_blank">
              <div className="tabBoxImg">
                <img src={skb} alt="logo" />
              </div>
              <p>
                Специальное конструкторское бюро часовых механизмов по
                разработке и производству механических приборов и устройств для
                авиастроения
              </p>
            </a>
          </div>
          {/* <div className="tabBoxInfo">
            <a href="" target="_blank">
              <div className="tabBoxImg">
                <img src={trinity} alt="logo" />
              </div>
              <p>
                Предприятие полного цикла по производству серверов и
                программно-аппаратных комплексов, включая их разработку,
                производство и обслуживание
              </p>
            </a>
          </div> */}
        </>
      ),
    },
    {
      id: "digital",
      title: "Цифровые решения",
      content: (
        <>
          <div className="tabBoxInfo">
            <a href="https://aitiguru.ru/" target="_blank">
              <div className="tabBoxImg">
                <img src={guru} alt="logo" />
              </div>
              <p>
                Разработчик и интегратор цифровых решений: ЕРП- и ЦРМ-систем,
                ИТ-инфраструктуры, мобильных приложений и веб-сайтов. Создатель
                программных продуктов, которые помогают компаниям управлять
                персоналом и бизнесом, автоматизируя процессы производства,
                логистики и финансов
              </p>
            </a>
          </div>
          <div className="tabBoxInfo">
            <div className="tabBoxImg">
              <img src={cifra} alt="logo" />
            </div>
            <p>
              Разработчик и интегратор российских цифровых решений и продуктов
              широкого профиля для автоматизации и оптимизации процессов
              безопасности, логистики, производства и других направлений
              деятельности
            </p>
          </div>
          {/* <div className="tabBoxInfo">
            <div className="tabBoxImg">
              <img src={complitech} alt="logo" />
            </div>
            <p>
              Разработчик экосистемы программного обеспечения для комплексных
              систем безопасности
            </p>
          </div> */}
        </>
      ),
    },
    {
      id: "innovations",
      title: "Инновации",
      content: (
        <>
          <div className="tabBoxInfo">
            <a href="https://inventorus.ru" target="_blank">
              <div className="tabBoxImg">
                <img src={iventorus} alt="logo" />
              </div>
              <p>
                Разработчик программного обеспечения для
                научно-исследовательской и инновационной инфраструктуры
              </p>
            </a>
          </div>
          <div className="tabBoxInfo">
            <a href="https://pognali.ru" target="_blank">
              <div className="tabBoxImg">
                <img src={pognali} alt="logo" />
              </div>
              <p>
                Платформа для развития внутреннего туризма, объединяющая
                интерактивные туристические порталы регионов России и
                маркетплейс турпродуктов в формате социальной сети для
                путешественников
              </p>
            </a>
          </div>
          <div className="tabBoxInfo">
            <div className="tabBoxImg">
              <img src={socrat} alt="logo" />
            </div>
            <p>
              Разработчик современных технологических решений в сфере
              безопасности и аналитической деятельности, основанных на анализе
              больших данных, технологиях моделирования, обработке цифрового
              следа по открытым источникам и применении искусственного
              интеллекта
            </p>
          </div>
        </>
      ),
    },
    // {
    //   id: "teknologiateknologia",
    //   title: "Технологии",
    //   content: (
    //     <>
    //       <div className="tabBoxInfo">
    //         <a href="https://pilottele.ru/" target="_blank">
    //           <img src={pilot} alt="logo" />
    //           <p>
    //             Производство оптических мультиплексоров, радиорелейных станций,
    //             специальных архитектурных башенных сооружений.
    //           </p>
    //         </a>
    //       </div>
    //     </>
    //   ),
    // },
  ];

  return (
    <div className="container">
      <div className="tabsBlock">
        <h3 className="title">Экосистема Консорциума</h3>
        <Tabs selectedIndex={activeTab} onSelect={handleTabSelect}>
          <TabList>
            {/* <button
              className="btnPrevTabs"
              onClick={handlePrev}
              disabled={activeTab === 0}
              aria-label="Previous tab"
            >
              <span className="prevTabs"></span>
            </button> */}
            {tabs.map((tab) => (
              <Tab key={`tab-${tab.id}`}>{tab.title}</Tab>
            ))}
            {/* <button
              className="btnNextTabs"
              onClick={handleNext}
              disabled={activeTab === tabs.length - 1}
              aria-label="Next tab"
            >
              <span className="nextTabs"></span>
            </button> */}
          </TabList>
          {tabs.map((tab, index) => (
            <TabPanel>
              <AnimatePresence mode="wait">
                {activeTab === index && (
                  <motion.div
                    key={`content-${tab.id}`}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    variants={tabVariants}
                    className="tab-content"
                  >
                    {/* {tab.content} */}
                    {React.Children.map(tab.content, (child, i) =>
                      React.cloneElement(child, {
                        key: `tabcontent-${tab.id}-${i}`,
                      }),
                    )}
                  </motion.div>
                )}
              </AnimatePresence>
            </TabPanel>
          ))}
        </Tabs>
      </div>
    </div>
  );
}
